import React, { useState, useEffect } from 'react';
import { Table, Select, Form, Row, Col } from 'antd';
import { parseISO, format } from 'date-fns';
import Rest from 'tools/rest';
import Preloader from 'components/preloader';
import InvoiceCardModal from './invoiceCardModal';

/** Список накладных с фильтром по складу поступления. */
const InvoicesJournal = ({ dataVersion, onDataChange }) => {
  const [rows, setRows] = useState([]);
  const [warehouses, setWarehouses] = useState([]);
  const [warehouseId, setWarehouseId] = useState(undefined);
  const [loading, setLoading] = useState(false);
  const [meta, setMeta] = useState({ current: 1, pageSize: 15, total: 0 });
  const [selectedInvoiceId, setSelectedInvoiceId] = useState(null);

  useEffect(() => {
    Rest.get('/api/v1/warehouses.json').then((r) =>
      setWarehouses(r.data.warehouses || [])
    );
  }, []);

  useEffect(() => {
    setLoading(true);
    const params = { page: meta.current, per: meta.pageSize };
    if (warehouseId != null && warehouseId !== '') {
      params.warehouse_id = warehouseId;
    }
    Rest.get('/api/v1/invoices.json', { params })
      .then((r) => {
        setRows(r.data.invoices || []);
        setMeta((prev) => ({
          ...prev,
          total: r.data.meta?.total || 0,
          current: r.data.meta?.page || prev.current,
        }));
      })
      .finally(() => setLoading(false));
  }, [meta.current, meta.pageSize, warehouseId, dataVersion]);

  const columns = [
    {
      title: 'Номер / название',
      dataIndex: 'name',
      ellipsis: true,
      width: '22%',
    },
    {
      title: 'Дата',
      dataIndex: 'invoice_date',
      width: '11%',
      render: (v) => (v ? format(parseISO(`${v}T12:00:00`), 'dd.MM.yyyy') : '—'),
    },
    {
      title: 'Склад',
      dataIndex: 'warehouse_name',
      width: '16%',
      render: (v) => v || '—',
    },
    {
      title: 'Файл',
      width: '20%',
      render: (_, record) => {
        if (record.document_url) {
          return (
            <a
              href={record.document_url}
              target="_blank"
              rel="noopener noreferrer"
              onClick={(e) => e.stopPropagation()}
            >
              {record.document_filename || 'Открыть'}
            </a>
          );
        }
        return <span style={{ color: '#999' }}>—</span>;
      },
    },
    {
      title: 'Создана',
      dataIndex: 'created_at',
      width: '14%',
      render: (v) => (v ? format(parseISO(v), 'dd.MM.yyyy HH:mm') : '—'),
    },
  ];

  return (
    <Preloader loading={loading}>
      <Row style={{ marginBottom: 16 }} gutter={16} align="middle">
        <Col>
          <Form layout="inline">
            <Form.Item label="Склад">
              <Select
                allowClear
                placeholder="Все склады"
                style={{ width: 240 }}
                value={warehouseId}
                onChange={(v) => {
                  setWarehouseId(v);
                  setMeta((m) => ({ ...m, current: 1 }));
                }}
                options={warehouses.map((w) => ({ value: w.id, label: w.name }))}
              />
            </Form.Item>
          </Form>
        </Col>
      </Row>
      <Table
        rowKey="id"
        size="small"
        columns={columns}
        dataSource={rows}
        onRow={(record) => ({
          onClick: () => setSelectedInvoiceId(record.id),
          style: { cursor: 'pointer' },
        })}
        pagination={{
          current: meta.current,
          pageSize: meta.pageSize,
          total: meta.total,
          showSizeChanger: true,
          onChange: (page, pageSize) => {
            setMeta((m) => ({ ...m, current: page, pageSize: pageSize || m.pageSize }));
          },
        }}
      />
      <InvoiceCardModal
        visible={!!selectedInvoiceId}
        invoiceId={selectedInvoiceId}
        onClose={() => setSelectedInvoiceId(null)}
        onSuccess={() => {
          if (onDataChange) onDataChange();
        }}
      />
    </Preloader>
  );
};

export default InvoicesJournal;
